import { css } from '@emotion/react';
import { Box, Typography, Paper } from '@mui/material';
import { RichText } from '@scorenco/components';
import { Types } from '@scorenco/core';

import { pickTextColorBasedOnBgColorSimple } from '../../utils';

const style = {
  root: css`
    max-width: 100vw;
    height: calc(100vh - 5rem);
    display: flex;
    z-index: -1;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    @keyframes floating {
      0% {
        transform: translate(0, 0px);
      }
      50% {
        transform: translate(0, 15px);
      }
      100% {
        transform: translate(0, -0px);
      }
    }
  `,
};

type ShortNewsProps = {
  screen: Types.Clubhouse_Screen;
};

export const ShortNews = ({ screen }: ShortNewsProps) => {
  return (
    <Box css={style.root}>
      {screen.news?.image && !screen.news?.title && !screen.news?.text ? (
        <Box
          component="img"
          src={screen.news?.image}
          sx={{
            width: '100%',
            height: '90%',
            objectFit: 'contain',
          }}
        />
      ) : (
        (screen.news?.image && (
          <Box
            sx={{
              display: 'flex',
              height: '100%',
              alignItems: 'center',
              width: '100%',
            }}
          >
            {screen.news?.title && !screen.news?.text && (
              <Box
                sx={{
                  position: 'absolute',
                  right: 0,
                  top: '3rem',
                  zIndex: 999,
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    textAlign: 'unset',
                    m: 0,
                    width: 'fit-content',
                    textTransform: 'uppercase',
                    mb: '5rem',
                    background: (theme) => theme.vars.palette.secondary.main,
                    pr: '2rem',
                    pl: '2rem',
                    pt: '0.5rem',
                    pb: '0.5rem',
                    color: (theme) =>
                      pickTextColorBasedOnBgColorSimple(
                        theme.vars.palette.secondary.main,
                        '#ffffff',
                        '#000000'
                      ),
                  }}
                >
                  {screen.news?.title}
                </Typography>
              </Box>
            )}
            {screen.news?.text && (
              <Box sx={{ flex: 1 }}>
                {screen.news?.title && (
                  <Typography
                    variant="h2"
                    sx={{
                      textAlign: 'unset',
                      m: 0,
                      width: 'fit-content',
                      textTransform: 'uppercase',
                      mb: '5rem',

                      background: (theme) => theme.vars.palette.secondary.main,
                      pr: '2rem',
                      pl: '2rem',
                      pt: '0.5rem',
                      pb: '0.5rem',
                      color: (theme) =>
                        pickTextColorBasedOnBgColorSimple(
                          theme.vars.palette.secondary.main,
                          '#ffffff',
                          '#000000'
                        ),
                    }}
                  >
                    {screen.news?.title}
                  </Typography>
                )}
                <RichText
                  sx={{ fontSize: '2rem', width: '80%', m: '0 auto' }}
                  content={screen.news?.text?.replace(/\n/g, '<br />')}
                />
              </Box>
            )}
            <Box
              sx={{
                flex: 1,
                background: (theme) =>
                  !screen.news?.title || !screen.news?.text
                    ? `unset`
                    : `${theme.vars.palette.secondary.main}50`,
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Paper
                sx={{
                  width: 'calc(100% - 15rem)',
                  height: 'calc(100% - 15rem)',
                  borderRadius: '1rem',
                  boxShadow: '0 0 100px #00000029',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  animation: 'floating 5s infinite ease-in-out',
                }}
              >
                <Box
                  component="img"
                  src={screen.news?.image}
                  sx={{
                    maxWidth: '90%',
                    maxHeight: '90%',
                  }}
                />
              </Paper>
            </Box>
          </Box>
        )) || (
          <>
            {screen.news?.title && (
              <Typography
                variant="h1"
                sx={{
                  fontStyle: 'italic',
                  textAlign: 'center',
                  m: 0,
                  textTransform: 'uppercase',
                  background: (theme) => theme.vars.palette.secondary.main,
                  pr: '2rem',
                  pl: '2rem',
                  pt: '0.5rem',
                  pb: '0.5rem',
                  maxWidth: '80%',
                  color: (theme) =>
                    pickTextColorBasedOnBgColorSimple(
                      theme.vars.palette.secondary.main,
                      '#ffffff',
                      '#000000'
                    ),
                  animation: 'floating 5s infinite ease-in-out',
                }}
              >
                {screen.news?.title}
              </Typography>
            )}
            <Box
              sx={{
                textAlign: 'center',
                maxWidth: '60%',
                p: '4rem',
                borderRadius: '2rem',
                background: 'unset',
              }}
            >
              <RichText
                sx={{ textAlign: 'center', m: 0, fontSize: '2.5rem' }}
                content={screen.news?.text?.replace(/\n/g, '<br />')}
              />
            </Box>
          </>
        )
      )}
    </Box>
  );
};
